import React, { createContext, useContext, useState } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [incidentSearchData, setIncidentSearchData] = useState([]);
  const [nameSearch, setnameSearch] = useState([]);
  const [arrestSearchData, setArrestSearchData] = useState([]);
  const [propertySearchData, setPropertySearchData] = useState([]);
  const [vehicleSearchData, setVehicleSearchData] = useState([]);
  const [searchCertificationData, setSearchCertificationData] = useState([]);
  const [recentSearchData, setRecentSearchData] = useState([]);
  const [searchObject, setSearchObject] = useState({});
  const [incidentSearchObj, setIncidentSearchObj] = useState({});

  return (
    <SearchContext.Provider
      value={{
        incidentSearchData,
        setIncidentSearchData,
        nameSearch,
        setnameSearch,
        arrestSearchData,
        setArrestSearchData,
        propertySearchData,
        setPropertySearchData,
        vehicleSearchData,
        setVehicleSearchData,
        searchCertificationData,
        setSearchCertificationData,
        recentSearchData,
        setRecentSearchData,
        searchObject,
        setSearchObject,
        incidentSearchObj,
        setIncidentSearchObj,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) throw new Error('useSearch must be used within SearchProvider');
  return context;
};

export default SearchContext;
